// redux/slices/plansSlice.js

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

//ENVIO DE SOLICITUD DE PLAN
export const updatePlan = createAsyncThunk(
  "plan/updatePlan",
  async ({ subscriptionPlanId }, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token");
      
      console.log("📤 Enviando solicitud al backend:", {
       
        subscriptionPlanId,
        endpoint: `${API_URL}/api/v1/userSubscriptions`
      });

      const response = await axios.post(
        `${API_URL}/api/v1/userSubscriptions`,
        {  subscriptionPlanId },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      console.log("✅ Respuesta del backend:", response.data);
      return response.data;
    } catch (err) {
      console.error("❌ Error en la petición:", {
        error: err.response?.data || err.message,
        status: err.response?.status,
        request: err.config
      });
      return rejectWithValue(
        err.response?.data?.message || "Error al crear solicitud de plan"
      );
    }
  }
);

// AsyncThunk para editar un plan
export const editPlan = createAsyncThunk(
  "plan/editPlan",
  async ({ planData, id }, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        throw new Error("No se encontró token de autenticación");
      }
      
      console.log("Actualizando plan:", {
        id,
        planData,
        endpoint: `${API_URL}/api/v1/subscriptionPlans/${id}`
      });

      const response = await axios.put(
        `${API_URL}/api/v1/subscriptionPlans/${id}`,
        planData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      console.log("Plan actualizado correctamente:", response.data);
      return response.data;
    } catch (err) {
      console.error("Error al actualizar el plan:", {
        error: err.response?.data || err.message,
        status: err.response?.status,
        request: err.config
      });
      
      // Capturar detalles específicos del error 403
      if (err.response?.status === 403) {
        return rejectWithValue({
          message: "Acceso denegado: Contacta al administrador para obtener permisos",
          status: 403,
          requiredRoles: ["admin"]
        });
      }
      
      return rejectWithValue(
        err.response?.data?.message || "Error al actualizar el plan"
      );
    }
  }
);
// AsyncThunk para crear un plan
export const createPlan = createAsyncThunk(
  "plan/createPlan",
  async (planData, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token");
      console.log(token, "token desde redux");
      const response = await axios.post(
        `${API_URL}/api/v1/subscriptionPlans`,
        planData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Error creating plan"
      );
    }
  }
);

// AsyncThunk para obtener planes
export const getPlan = createAsyncThunk(
  "plan/getPlan",
  async (_, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(`${API_URL}/api/v1/subscriptionPlans`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Error getting plan"
      );
    }
  }
);



//AsyncThunk para eliminar planes
export const deletePlan = createAsyncThunk(
  "plans/deletePlan",
  async (id, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.delete(
        `${API_URL}/api/v1/subscriptionPlans/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return id;
    } catch (err) {
      console.log(err);

      return rejectWithValue(
        err.response?.data?.message || "Error deleting plan"
      );
    }
  }
);

// Slice
const plansSlice = createSlice({
  name: "plan",
  initialState: {
    plans: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Crear plan
      .addCase(createPlan.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createPlan.fulfilled, (state, action) => {
        state.loading = false;
        state.plans.push(action.payload);
      })
      .addCase(createPlan.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Obtener planes
      .addCase(getPlan.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getPlan.fulfilled, (state, action) => {
        state.loading = false;
        state.plans = action.payload;
      })
      .addCase(getPlan.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      //Actualizar planes
      .addCase(updatePlan.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updatePlan.fulfilled, (state, action) => {
        state.loading = false;
        const index = state.plans.findIndex(
          (plan) => plan.id === action.payload.id
        );

        if (index !== -1) {
          state.plans[index] = action.payload;
        }
      })
      .addCase(updatePlan.rejected, (state, action) => {
        state.loading = false;
        console.log(state.error);

        state.error = action.payload;
      })
      
      //Editar planes
      .addCase(editPlan.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(editPlan.fulfilled, (state, action) => {
        state.loading = false;
        const index = state.plans.findIndex(
          (plan) => plan.id === action.payload.id
        );

        if (index !== -1) {
          state.plans[index] = action.payload;
        }
      })
      .addCase(editPlan.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      //Eliminar planes
      .addCase(deletePlan.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deletePlan.fulfilled, (state, action) => {
        state.loading = false;
        state.plans = state.plans.filter((plan) => plan.id !== action.payload);
      })
      .addCase(deletePlan.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default plansSlice.reducer;
